export default "__VITE_ASSET__BRp6c7Zi__"